angular.module('unica_partner.partner_services', []);